"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopper = require("react-popper");

var _oxygenStaticTooltip = _interopRequireDefault(require("@8x8/oxygen-static-tooltip"));

var _oxygenConfig = require("@8x8/oxygen-config");

var _themeName = _interopRequireDefault(require("../constants/themeName"));

var _directions = _interopRequireDefault(require("../constants/directions"));

var _showOnTypes = _interopRequireDefault(require("../constants/showOnTypes"));

var _mergeElementEvents = require("../utils/mergeElementEvents");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var registerEventHandlers = function registerEventHandlers(handlers) {
  if (!Array.isArray(handlers)) {
    return;
  }

  var _iterator = _createForOfIteratorHelper(handlers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var handler = _step.value;
      handler.target.addEventListener(handler.eventName, handler.callback, handler.capture);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var unregisterEventHandlers = function unregisterEventHandlers(handlers) {
  if (!Array.isArray(handlers)) {
    return;
  }

  var _iterator2 = _createForOfIteratorHelper(handlers),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var handler = _step2.value;
      handler.target.removeEventListener(handler.eventName, handler.callback, handler.capture);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};

var Tooltip = /*#__PURE__*/function (_Component) {
  _inherits(Tooltip, _Component);

  var _super = _createSuper(Tooltip);

  function Tooltip(props) {
    var _this;

    _classCallCheck(this, Tooltip);

    _this = _super.call(this, props);
    _this.state = {
      isShown: false
    };

    _this.getShowHandler = function () {
      var showOn = _this.props.showOn;
      return showOn === _showOnTypes["default"].click ? {
        onClick: _this.toggleTooltip
      } : {
        onMouseEnter: _this.showTooltip,
        onMouseLeave: _this.hideTooltip
      };
    };

    _this.showTooltip = function () {
      registerEventHandlers(_this.closeHandlers);
      var delay = _this.props.delay;
      _this.displayTimeout = setTimeout(function () {
        _this.setState({
          isShown: true
        });
      }, delay);
    };

    _this.hideTooltip = function () {
      unregisterEventHandlers(_this.closeHandlers);
      clearTimeout(_this.displayTimeout);

      _this.setState({
        isShown: false
      });
    };

    _this.toggleTooltip = function () {
      var isShown = _this.state.isShown;

      if (!isShown) {
        _this.showTooltip();
      } else {
        _this.hideTooltip();
      }
    };

    _this.addHideCallback = function (customCloseHandlers) {
      return customCloseHandlers.map(function (handler) {
        return Object.assign({}, handler, {
          callback: _this.hideTooltip
        });
      });
    };

    _this.renderContent = function () {
      var _this$props = _this.props,
          theme = _this$props.theme,
          testId = _this$props.testId,
          title = _this$props.title,
          orientation = _this$props.orientation,
          triggerRef = _this$props.triggerRef;
      var placement = _directions["default"][orientation] || orientation;
      return /*#__PURE__*/_react["default"].createElement(_reactPopper.Popper, {
        placement: placement,
        positionFixed: true,
        referenceElement: triggerRef,
        modifiers: {
          offset: {
            offset: '0, 5'
          }
        }
      }, function (_ref) {
        var ref = _ref.ref,
            style = _ref.style;
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: ref,
          style: style
        }, /*#__PURE__*/_react["default"].createElement(_oxygenStaticTooltip["default"], {
          theme: theme,
          testId: "STATIC_TOOLTIP_FOR_".concat(testId)
        }, title));
      });
    };

    _this.renderContentInsideContainer = function () {
      var renderContainer = _this.props.renderContainer;
      return /*#__PURE__*/_reactDom["default"].createPortal(_this.renderContent(), renderContainer);
    };

    _this.renderChildren = function () {
      var _this$props2 = _this.props,
          testId = _this$props2.testId,
          children = _this$props2.children,
          includeWrapper = _this$props2.includeWrapper;

      var renderWithoutWrapper = function renderWithoutWrapper(ref) {
        return _react["default"].Children.map(children || null, function (child) {
          return /*#__PURE__*/_react["default"].cloneElement(child, Object.assign({
            ref: ref
          }, (0, _mergeElementEvents.mergeElementEvents)(_this.getShowHandler(), child)));
        });
      };

      var renderWithWrapper = function renderWithWrapper(ref) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          ref: ref
        }, _this.getShowHandler(), (0, _oxygenConfig.getTestAttributes)("ANCHOR_FOR_".concat(testId))), children);
      };

      return /*#__PURE__*/_react["default"].createElement(_reactPopper.Reference, null, function (_ref2) {
        var ref = _ref2.ref;
        return includeWrapper ? renderWithWrapper(ref) : renderWithoutWrapper(ref);
      });
    };

    var _customCloseHandlers = _this.props.customCloseHandlers;
    _this.closeHandlers = [{
      target: document.body,
      eventName: 'click',
      callback: _this.hideTooltip,
      capture: true
    }, {
      target: document.body,
      eventName: 'contextmenu',
      callback: _this.hideTooltip,
      capture: true
    }].concat(_toConsumableArray(_this.addHideCallback(_customCloseHandlers)));
    return _this;
  }

  _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var renderContainer = this.props.renderContainer;
      var isShown = this.state.isShown;
      return /*#__PURE__*/_react["default"].createElement(_reactPopper.Manager, null, this.renderChildren(), isShown && (renderContainer ? this.renderContentInsideContainer() : this.renderContent()));
    }
  }]);

  return Tooltip;
}(_react.Component);

Tooltip.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,
  testId: _propTypes["default"].string,
  delay: _propTypes["default"].number,
  orientation: _propTypes["default"].string,
  showOn: _propTypes["default"].oneOf(Object.values(_showOnTypes["default"])),
  children: _propTypes["default"].node,
  triggerRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  customCloseHandlers: _propTypes["default"].array,
  renderContainer: _propTypes["default"].instanceOf(window.Element),
  includeWrapper: _propTypes["default"].bool,
  theme: _propTypes["default"].object
};
Tooltip.defaultProps = {
  delay: 0,
  testId: 'TOOLTIP',
  orientation: _directions["default"].top,
  showOn: _showOnTypes["default"].hover,
  children: null,
  triggerRef: undefined,
  customCloseHandlers: [],
  renderContainer: undefined,
  includeWrapper: true,
  theme: undefined
};

var _default = (0, _oxygenConfig.withTheme)(Tooltip, _themeName["default"]);

exports["default"] = _default;